/* eslint-disable camelcase */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import { CoveoProductContextModel } from "@NA/Components/Coveo/Contexts/CoveoProductContext";
import { getProductCollectionRealTimePrices } from "@NA/Overrides/Services/ProductServiceV2";
import { CoveoProductModel } from "@NA/Types/CoveoModel";
import _ from "lodash";

export function getProductCompareChecked(state: ApplicationState, productContext: CoveoProductContextModel) {
    if (productContext && productContext.coveoProduct) {
        return state.components.compareProductsDrawer.productsIds.includes(productContext.coveoProduct.productId);
    }
    return false;
}

export const getRealTimePricing = async (products: any) => {
    const apiParameter: any = [];
    products.forEach((item: any) => {
        apiParameter.push({
            productId: item.productId,
            unitOfMeasure: item.unitofmeasure,
            qtyOrdered: 1,
        });
    });
    try {
        const result = await getProductCollectionRealTimePrices({ productPriceParameters: apiParameter });
        return result;
    } catch (error) {
        console.error("Error occurred >>:", error);
    }
};

export const updateRealTimePricingForProducts = (products: CoveoProductModel[], realTimePricing: ProductPriceDto[]) => {
    if (realTimePricing && realTimePricing.length) {
        return products.map((p: any) => {
            const product = _.cloneDeep(p);
            const currentProduct = realTimePricing.find(item => item.productId === product.productId.toLowerCase());
            if (currentProduct) {
                product.pricing = currentProduct;
                product.showAuthorizationRequired = !!(
                    currentProduct &&
                    currentProduct.additionalResults &&
                    currentProduct.additionalResults.isVisible &&
                    currentProduct.additionalResults.isVisible === "N"
                );
            }
            return product;
        });
    }
    return products;
};

export const isCoveoSearchEnabled = (settingsCollection: any, isCoveoUser: boolean) => {
    const CoveoForAllUsers = settingsCollection && settingsCollection.adiCoveoSearchSettingSettings?.enableCoveoSearchToAllTheUsers;
    if (CoveoForAllUsers || isCoveoUser) { return true; }
    return false;
};

